import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ProductsService } from '../../services/products.service';
import { EventEmitterService } from '../../services/event-emitter.service';
import { UsersService } from '../../services/users.service';

@Component({
  standalone: false,
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
})
export class ResetPasswordComponent implements OnInit {
  formGroup: FormGroup;
  isError = false;
  isErrorText = 'something-went-wrong';

  constructor(
    public bsModalRef: BsModalRef,
    private usersService: UsersService,
    private eventEmitterService: EventEmitterService,
  ) {}

  ngOnInit() {
    this.setupForm();
  }

  setupForm() {
    this.formGroup = new FormGroup({
      old_password: new FormControl('', Validators.required),
      new_password: new FormControl('', Validators.required),
      confirm_new_password: new FormControl('', Validators.required),
    });
  }

  closeModal() {
    this.bsModalRef.hide();
  }

  buttonClicked() {
    this.isError = false;
    this.isErrorText = 'something-went-wrong';
    this.formGroup.markAllAsTouched();

    if (this.formGroup.invalid) {
      return;
    }

    const new_password = this.formGroup.get('new_password').value;
    const confirm_new_password = this.formGroup.get(
      'confirm_new_password',
    ).value;
    if (new_password.trim() === '' || new_password.length < 8) {
      this.isError = true;
      this.isErrorText = 'password-is-not-valid';
      return;
    }
    if (new_password !== confirm_new_password) {
      this.isError = true;
      this.isErrorText = 'passwords-are-not-equal';
      return;
    }

    this.usersService.resetPassword(this.formGroup.value).subscribe(
      (response) => {
        console.log('response:');
        console.log(response);
        this.closeModal();
      },
      (error) => {
        console.log('error:');
        console.log(error);
        this.isError = true;
        this.isErrorText = 'something-went-wrong';
      },
    );
  }
}
